// #region Global Imports
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
// #endregion Global Imports
const brown = "#8c6c4d";
const dark_blue = "#303c49";
const grey = "#706f6f";
const light_grey = "#d9d9d9";
const popat_green = "#bcd75f";
const popat_dark_green = "#abc64f";
const dark_green = "#00844a";

const lightest_grey = "#ededed";

const subtitle1Color = "#8d6c4d";
let theme = createTheme({
  // overridding material ui default styles
  typography: {
    fontFamily: "Gotham-Book",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 700,
      color: dark_blue,

      "@media (max-width:600px)": {
        fontSize: "1.3rem",
      },
    },
    h6: {
      fontWeight: 500,
      color: dark_blue,
    },
    subtitle1: {
      fontSize: "1.5rem",
      color: subtitle1Color,
      "@media (max-width:600px)": {
        fontSize: "1.3rem",
      },
    },
    subtitle2: {
      fontWeight: 300,
      fontFamily: "Gotham-xLight",
      // color: subtitle1Color,
      fontSize: "1.5rem",
      "@media (max-width:600px)": {
        fontSize: "1.25rem",
      },
      "@media (max-width:400px)": {
        fontSize: "1rem",
      },
    },
    body1: {
      // fontWeight: 300,

      color: dark_blue,
    },
  },
  components: {
    MuiRating: {
      defaultProps: {
        precision: 0.5,
        style: { color: dark_green },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "10px",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          border: 0,
          width: "1px",
          background:
            "linear-gradient(90deg, hsla(41, 100%, 50%, 1) 0%, hsla(162, 100%, 35%, 1) 48%, hsla(202, 100%, 46%, 1) 100%)",
          filter: `progid: DXImageTransform.Microsoft.gradient( startColorstr="#FFAE00", endColorstr="#00B27E", GradientType=1 )`,
        },
      },
    },
  },
  palette: {
    primary: {
      main: dark_green,
      light: `rgba(0, 132, 74,0.1)`,
    },
    secondary: {
      main: light_grey,
      light: lightest_grey,
      dark: grey,
    },
    neutral: {
      main: popat_green,
      dark: popat_dark_green,
    },
    brown: {
      main: subtitle1Color,
      dark: brown,
    },
  },

  colors: {
    primary: "rgb(0,128,0)",
    secondary: "#808080",
    blue_line: "#00a3d1",
  },
  // declaring new theme constants
  bg: {
    main: "#fff",
    light: "#F4F5F7",
  },
  text: {
    main: "#172B4D",
    light: "#262930",
  },
});

// theme = responsiveFontSizes(theme);
export { theme };
